export default {
    baseUrl: 'https://sharework-admin.codeseye.com/',
    api: 'https://sharework-admin.codeseye.com/backend/',
}
